export default __webpack_public_path__ + "static/media/assembly-disassembly-security-icon.9c540bbf.svg";